import React from 'react';
import SurveyPage from '../components/SurveyPage';
import SurveyTitleArea from '../components/SurveyTitleArea';
import SurveySection from '../components/SurveySection';
import SurveyElement from '../components/SurveyElement';
import SurveyContentContainer from '../components/SurveyContentContainer';
import {
  ElementType,
  NumberFormat, PlaceholderFormat,
} from '../Enums/constants';
import {getCurrencyPlaceHolder} from "../helpers";


export const PabsStartTab = () => {
  let currencyPlaceHolderBillions = getCurrencyPlaceHolder(PlaceholderFormat.CURRENCY_BILLIONS);
  
  return (
    <SurveyPage>
      <SurveyTitleArea pageName="Start" />
      <SurveyContentContainer>
        <SurveySection labelText="Start" >
          <SurveyElement
            questionNumber="1"
            labelText="System Name"
            inputType={ElementType.TEXT}
            name="Longname"
          />
          <SurveyElement
            questionNumber="2"
            labelText="Main Survey Contact"
          />
          <SurveyElement
            questionNumber="2.a"
            labelText="Name"
            inputType={ElementType.TEXT}
            name="Name"
            subQuestion
          />
          <SurveyElement
            questionNumber="2.b"
            labelText="Job Title"
            inputType={ElementType.TEXT}
            name="Title"
            subQuestion
          />
          <SurveyElement
            questionNumber="2.c"
            labelText="Email"
            inputType={ElementType.TEXT}
            name="Email"
            subQuestion
          />
          <SurveyElement
            questionNumber="2.d"
            labelText="Telephone"
            inputType={ElementType.TEXT}
            name="Telephone"
            subQuestion
          />
        </SurveySection>
        <SurveySection labelText="Plan Description" >
          <SurveyElement
            questionNumber="3"
            labelText="What is the month of your fiscal year end?"
            inputType={ElementType.SELECT}
            name="Q_217"
            options={["", "January", "March", "May", "June", "August", "September", "December"]}
            note="All questions in this survey are for your most recently completed fiscal year."
          />
          <SurveyElement
            questionNumber="4"
            labelText="What was the end of fiscal year value of your pension fund assets (in billions)?"
            inputType={ElementType.NUMBER}
            name="Assets"
            format={NumberFormat.MONEYBILLION}
            placeholder={currencyPlaceHolderBillions}
            allowNA
            allowUnknown
          />
          <SurveyElement
            questionNumber="5"
            labelText="Is your organization's leadership (i.e., CEO, CFO) also responsible for investments? "
            inputType={ElementType.SELECT}
            name="LeadershipResponsibleInvestment"
            options={["", "Yes", "No", "N/A"]}
          />
        </SurveySection>
      </SurveyContentContainer>
    </SurveyPage>
  );
}